import { set } from 'cerebral/operators';
import { state, props } from 'cerebral/tags';

export default [set(state`app.answers.tips.${props`part`}.${props`section`}`, props`tip`)];
